import { GameSoundsContext } from "./GameSoundContext"
import { 
    NAME_SOUND_FINAL_COUNTDOWN,NAME_SOUND_INTRO, NAME_SOUND_ACTIVE_BANK, NAME_SOUND_HOVER, NAME_SOUND_POINTS, NAME_SOUND_FAILURE,
    NAME_SOUND_LIVE, NAME_SOUND_COUNTDOWN, NAME_SOUND_WIN, NAME_SOUND_LOSS, NAME_SOUND_POINTS_COUNT, NAME_SOUND_SUCCESS, NAME_SOUND_WRONG,
    NAME_SOUND_ACTIVE, NAME_SOUND_CHARGE
} from "../../utils";
import { assetsUrl } from "../../utils";
import { useCallback, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";

const SHARED_AUDIOS = {
    [NAME_SOUND_INTRO]: assetsUrl('common/intro.mp3'),
    [NAME_SOUND_ACTIVE_BANK]: assetsUrl('common/enunciado.mp3'),
    [NAME_SOUND_HOVER]: assetsUrl('common/hover.mp3'),
    [NAME_SOUND_POINTS]: assetsUrl('common/puntos.mp3'),
    [NAME_SOUND_FAILURE]: assetsUrl('common/fallo.mp3'),
    [NAME_SOUND_SUCCESS]: assetsUrl('common/bien.mp3'),
    [NAME_SOUND_WRONG]: assetsUrl('common/mal.mp3'),
    [NAME_SOUND_LIVE]: assetsUrl('common/vida.mp3'),
    [NAME_SOUND_COUNTDOWN]: assetsUrl('common/countdown.mp3'),
    [NAME_SOUND_WIN]: assetsUrl('common/ganado.mp3'),
    [NAME_SOUND_LOSS]: assetsUrl('common/perdido.mp3'),
    [NAME_SOUND_POINTS_COUNT]: assetsUrl('common/conteopuntos.mp3'),
    [NAME_SOUND_FINAL_COUNTDOWN]: assetsUrl('common/tiempoatrasfinal.mp3'),
    [NAME_SOUND_ACTIVE]: assetsUrl('common/activo.mp3'),
    [NAME_SOUND_CHARGE]: assetsUrl('common/carga.mp3')
}

const createAudioAndPlay = (src) => {
    if (typeof src !== 'string' || !src.trim()) {
        console.error('Invalid audio source:', src);
        return;
    }

    try {
        const audio = new Audio(src);
        const playPromise = audio.play();
        
        if (playPromise instanceof Promise) {
            playPromise.catch(error => {
                console.error('Error playing audio:', error);
            });
        }
    } catch (error) {
        console.error('Error creating audio:', error);
    }
}

export function GameSoundsProvider({ children, sounds = {} }) {

    const [soundActive, setSoundActive] = useState(true);
    const [specificSoundActive, setSpecificSoundActive] = useState(true);

    const audios = useMemo(() => {
        Object.keys(sounds).forEach(key => {
            if (SHARED_AUDIOS[key]) {
                throw new Error(`Invalid sound name: ${key}`);
            }
        })

        return {
            ...SHARED_AUDIOS,
            ...sounds
        }
    }, [sounds]);

    useEffect(() => {
        // preload all sounds
        const head = document.getElementsByTagName('head')[0];
        const fragmnt = document.createDocumentFragment();

        Object.values(audios).forEach((src) => {
            const link = document.createElement('link');
            link.rel = 'prefetch'
            link.as = 'audio';
            link.href = src;
            fragmnt.appendChild(link);
        });

        head.appendChild(fragmnt);

        return () => {
            Object.values(audios).forEach((src) => {
                const link = document.querySelector(`link[href="${src}"]`);
                link.remove();
            });
        }
    }, [audios]);

    const play = useCallback(soundName => {
        if(!soundActive) return;

        const src = audios[soundName];

        if (!src) {
            throw new Error(`Invalid sound name: ${soundName}`);
        }

        createAudioAndPlay(src);
    }, [audios,soundActive]);

    return (
        <GameSoundsContext.Provider value={{ soundActive, setSoundActive, play, specificSoundActive, setSpecificSoundActive }}>
            {children}
        </GameSoundsContext.Provider>
    )
}

GameSoundsProvider.propTypes = {
    children: PropTypes.node,
    sounds: PropTypes.object
}